// Compare slider (homepage "See the difference" and PDP before/after) — drag-only interaction.
// The native <input type=range> this used to rely on is now pointer-events:none (see
// adapt-global-fixes.css), because native ranges JUMP the value to wherever you click, which is
// what made the slider feel like it triggered from any touch on the image. This replaces that
// with real drag tracking: position only updates while the pointer is actually held down AND has
// moved past a small threshold — a plain tap does nothing.
//
// MOUSE DRAG FIX (2026-08-12): mouse dragging didn't work at all, only touch did. Root cause —
// pointerdown never called preventDefault(), so pressing and dragging on the <img> itself
// triggered the browser's native "drag this image" gesture (the ghost-thumbnail drag-to-save
// behavior every browser attaches to <img> elements by default). That native drag hijacks the
// gesture entirely, so pointermove on el never fires again for the rest of that drag. Touch has
// no equivalent native gesture, which is why it worked there but not with a mouse. Fixed by
// preventDefault()'ing on pointerdown (blocks the native image-drag from ever starting) and
// adding draggable="false" + user-drag:none as a second layer of the same fix.
(function(){
  function initCompare(el){
    var dragging = false;
    var moved = false;
    var startX = 0;

    // belt-and-suspenders: also kill native drag at the element level, not just via
    // preventDefault in the handler below, in case some browser still tries.
    el.querySelectorAll('img').forEach(function(img){
      img.setAttribute('draggable', 'false');
      img.addEventListener('dragstart', function(e){ e.preventDefault(); });
    });

    function setPos(clientX){
      var rect = el.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      el.style.setProperty('--pos', pct);
      var range = el.querySelector('.ad-cmp__range');
      if(range) range.value = pct;
    }

    el.addEventListener('pointerdown', function(e){
      dragging = true;
      moved = false;
      startX = e.clientX;
      e.preventDefault();
      el.setPointerCapture && el.setPointerCapture(e.pointerId);
    });

    el.addEventListener('pointermove', function(e){
      if(!dragging) return;
      if(!moved && Math.abs(e.clientX - startX) < 4) return;
      moved = true;
      setPos(e.clientX);
    });

    function endDrag(){
      dragging = false;
      moved = false;
    }
    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
    el.addEventListener('pointerleave', function(){ if(dragging && !moved){ dragging = false; } });
  }

  document.querySelectorAll('.ad-cmp').forEach(initCompare);
})();
